import { css } from "styled-components";
import {
  REGISTRATION_ERROR,
  REGISTRATION_FOCUS_GLOW,
  REGISTRATION_FOCUS_RING,
  REGISTRATION_FONT_BODY,
  REGISTRATION_FONT_DISPLAY,
  REGISTRATION_FOREST,
  REGISTRATION_HOVER_FILL,
  REGISTRATION_LINK,
  REGISTRATION_ON_PRIMARY,
  REGISTRATION_PLACEHOLDER,
  REGISTRATION_PRIMARY,
  REGISTRATION_PRIMARY_DARK,
} from "./registrationTheme";
import { registrationReducedMotionStyles } from "./registrationMotionStyles";

const registrationButtonBase = css`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 14px 28px;
  border-radius: 999px;
  font-family: ${REGISTRATION_FONT_BODY};
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
`;

export const registrationFormStyles = css`
  ${registrationReducedMotionStyles}

  .section-eyebrow {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 1.2px;
    text-transform: uppercase;
    color: ${REGISTRATION_LINK};
    margin-bottom: 8px;
    font-family: ${REGISTRATION_FONT_BODY};
  }

  .section-title {
    font-family: ${REGISTRATION_FONT_DISPLAY};
    font-size: 22px;
    font-weight: 500;
    color: ${REGISTRATION_FOREST};
    line-height: 1.2;
    margin-bottom: 10px;

    @media (min-width: 600px) {
      font-size: 26px;
    }

    em {
      font-style: italic;
      color: ${REGISTRATION_LINK};
    }
  }

  .section-sub {
    font-size: 14px;
    color: ${REGISTRATION_FOREST};
    line-height: 1.65;
    margin-bottom: 24px;
    font-family: ${REGISTRATION_FONT_BODY};
  }

  .form-row {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    gap: 14px;
    overflow: visible;
    padding: 2px;

    @media (max-width: 640px) {
      grid-template-columns: minmax(0, 1fr);
    }
  }

  .form-row .form-group {
    margin-bottom: 16px;
    min-width: 0;
    width: 100%;
    max-width: 100%;
  }

  .form-group {
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-bottom: 16px;
    min-width: 0;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
  }

  .form-group > .form-input,
  .form-group > .form-select-wrap,
  .form-group > .form-select,
  .form-group > select.form-input,
  .form-group > .password-input-wrap,
  .form-group > .reg-dob-field,
  .form-group > .reg-dob-datepicker {
    width: 100%;
    max-width: 100%;
    min-width: 0;
  }

  .reg-dob-field {
    position: relative;
    width: 100%;
  }

  .reg-dob-input {
    padding-right: 44px;
    width: 100%;
  }

  .reg-dob-calendar-btn {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 2;
    border: none;
    background: transparent;
    color: #5a6b80;
    cursor: pointer;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 0;

    &:hover:not(:disabled) {
      color: #2a2a2a;
    }

    &:disabled {
      cursor: not-allowed;
      opacity: 0.45;
    }
  }

  .reg-dob-native-picker {
    position: absolute;
    right: 8px;
    top: 50%;
    width: 32px;
    height: 32px;
    margin: 0;
    padding: 0;
    border: 0;
    opacity: 0;
    pointer-events: none;
    transform: translateY(-50%);
  }

  .reg-dob-datepicker {
    width: 100%;
    padding: 12px 16px;
    border: 1.5px solid rgba(30, 42, 53, 0.15);
    border-radius: 10px;
    font-family: ${REGISTRATION_FONT_BODY};
    font-size: 15px;
    background-color: #ffffff;
    color: #2a2a2a;
    transition: border-color 0.2s, box-shadow 0.2s;

    &:hover {
      border-color: ${REGISTRATION_FOCUS_RING};
      box-shadow: 0 0 0 3px ${REGISTRATION_FOCUS_GLOW};
    }

    &.ant-picker-focused,
    &.ant-calendar-picker-focused {
      border-color: ${REGISTRATION_FOCUS_RING};
      box-shadow: 0 0 0 3px ${REGISTRATION_FOCUS_GLOW};
    }

    .ant-picker-input > input,
    .ant-calendar-picker-input > input {
      font-family: ${REGISTRATION_FONT_BODY};
      font-size: 15px;
      color: #2a2a2a;
    }

    .ant-picker-suffix,
    .ant-calendar-picker-icon {
      color: #5a6b80;
    }
  }

  .reg-dob-datepicker-dropdown {
    z-index: 1050;

    .ant-picker-cell,
    .ant-calendar-cell {
      background: transparent !important;
    }

    .ant-picker-cell-disabled::before,
    .ant-calendar-disabled-cell .ant-calendar-date {
      background: transparent !important;
    }

    .ant-picker-cell-disabled .ant-picker-cell-inner,
    .ant-calendar-disabled-cell .ant-calendar-date {
      background: transparent !important;
      color: rgba(0, 0, 0, 0.25) !important;
    }

    tr,
    .ant-picker-content tbody tr {
      background: transparent !important;
    }

    .ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner,
    .ant-calendar-selected-day .ant-calendar-date {
      background: #1890ff !important;
      color: #fff !important;
    }

    .ant-picker-today-btn,
    .ant-calendar-today-btn {
      color: #1890ff;
    }
  }

  .password-input-wrap {
    position: relative;
    display: block;
  }

  .password-input-wrap .form-input {
    padding-right: 44px;
  }

  .password-toggle-btn {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    border: none;
    background: none;
    padding: 4px;
    cursor: pointer;
    color: #5a6b80;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 0;

    &:hover {
      color: #2a2a2a;
    }

    &:focus-visible {
      outline: 3px solid ${REGISTRATION_FOCUS_RING};
      outline-offset: 2px;
      border-radius: 4px;
    }
  }

  .form-select-wrap {
    position: relative;
    display: block;
  }

  .form-select-wrap .form-select-icon {
    position: absolute;
    right: 14px;
    top: 0;
    bottom: 0;
    margin: auto 0;
    pointer-events: none;
    transition: transform 0.2s ease;
  }

  .form-select-wrap:focus-within .form-select-icon {
    -ms-transform: rotate(270deg);
    transform: rotate(270deg);
  }

  .form-label {
    font-size: 13px;
    font-weight: 600;
    color: ${REGISTRATION_FOREST};
    font-family: ${REGISTRATION_FONT_BODY};
  }

  .required-mark {
    color: ${REGISTRATION_ERROR};
  }

  .registration-sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    clip-path: inset(50%);
    white-space: nowrap;
    border: 0;
  }

  .form-input,
  .form-select {
    padding: 12px 16px;
    border: 1.5px solid rgba(30, 42, 53, 0.15);
    border-radius: 10px;
    font-family: ${REGISTRATION_FONT_BODY};
    font-size: 15px;
    background-color: #ffffff;
    color: #2a2a2a;
    outline: none;
    width: 100%;
    box-sizing: border-box;
    transition: border-color 0.2s, box-shadow 0.2s;

    &::placeholder {
      color: ${REGISTRATION_PLACEHOLDER};
      opacity: 1;
    }

    &:hover:not(.form-input--invalid) {
      border-color: ${REGISTRATION_FOCUS_RING};
    }

    &:focus {
      border-color: ${REGISTRATION_FOCUS_RING};
      box-shadow: 0 0 0 3px ${REGISTRATION_FOCUS_GLOW};
    }

    &.form-input--invalid {
      border-color: ${REGISTRATION_ERROR};
    }

    &.form-input--invalid:focus {
      border-color: ${REGISTRATION_ERROR};
      box-shadow: 0 0 0 3px rgba(184, 72, 26, 0.18);
    }
  }

  .form-select,
  select.form-input {
    cursor: pointer;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: #ffffff;
    color: #2a2a2a;
    text-shadow: none;
    padding-right: 36px;
    text-indent: 0;
    line-height: 1.4;
    min-height: 44px;
  }

  .form-select option,
  select.form-input option {
    color: #2a2a2a;
    background-color: #ffffff;
    text-shadow: none;
  }

  .form-select:-moz-focusring,
  select.form-input:-moz-focusring {
    color: #2a2a2a;
    text-shadow: none;
    outline: none;
  }

  .form-select::-moz-focus-inner,
  select.form-input::-moz-focus-inner {
    border: 0;
  }

  .divider {
    height: 1px;
    background: rgba(30, 42, 53, 0.1);
    margin: 8px 0 20px;
  }

  .form-hint {
    font-size: 11px;
    color: ${REGISTRATION_FOREST};
    margin-top: 2px;
    font-family: ${REGISTRATION_FONT_BODY};
    line-height: 1.45;
  }

  .text-danger {
    color: ${REGISTRATION_ERROR} !important;
    font-size: 12px;
    font-family: ${REGISTRATION_FONT_BODY};
    display: flex;
    align-items: flex-start;
    gap: 6px;
    line-height: 1.45;
  }

  .text-danger-icon {
    display: inline-flex;
    flex-shrink: 0;
    margin-top: 1px;
    line-height: 0;
  }

  .field-group-label {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.8px;
    color: ${REGISTRATION_FOREST};
    margin-bottom: 8px;
    font-family: ${REGISTRATION_FONT_BODY};
  }

  .insurance-details-grid {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    gap: 14px;
    margin-bottom: 16px;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    box-sizing: border-box;

    @media (max-width: 640px) {
      grid-template-columns: minmax(0, 1fr);
    }
  }

  .insurance-details-grid .form-group {
    margin-bottom: 0;
    min-width: 0;
  }

  .insurance-details-grid .form-group.insurance-details-span-2 {
    grid-column: 1 / -1;
  }

  .insurance-details-grid .form-input,
  .insurance-details-grid .form-select,
  .insurance-details-grid .reg-dob-field,
  .insurance-details-grid .reg-dob-input,
  .insurance-details-grid .reg-dob-datepicker {
    width: 100%;
    max-width: 100%;
  }

  .notice-box {
    background: rgba(174, 206, 56, 0.08);
    border: 1px solid rgba(174, 206, 56, 0.25);
    border-radius: 10px;
    padding: 14px 16px;
    display: flex;
    gap: 12px;
    align-items: flex-start;
    margin-bottom: 12px;
  }

  .notice-box.nutrition {
    margin-bottom: 24px;
  }

  .notice-box--warning {
    background: rgba(240, 175, 66, 0.09);
    border-color: rgba(240, 175, 66, 0.3);
    margin-bottom: 20px;
  }

  .notice-box--coverage {
    background: rgba(90, 107, 128, 0.07);
    border: 1px solid rgba(90, 107, 128, 0.15);
    border-radius: var(--radius-sm);
  }

  .notice-icon {
    font-size: 16px;
    flex-shrink: 0;
    margin-top: 1px;
  }

  .notice-text {
    font-size: 13px;
    color: ${REGISTRATION_FOREST};
    line-height: 1.55;
    font-family: ${REGISTRATION_FONT_BODY};

    strong {
      font-weight: 600;
    }
  }

  .btn-primary {
    ${registrationButtonBase}
    border: none;
    background: ${REGISTRATION_PRIMARY};
    color: ${REGISTRATION_ON_PRIMARY};
    margin-top: 8px;

    &:hover:not(:disabled) {
      background: ${REGISTRATION_PRIMARY_DARK};
      color: ${REGISTRATION_ON_PRIMARY};
      transform: translateY(-1px);
      box-shadow: 0 6px 20px ${REGISTRATION_FOCUS_GLOW};
    }

    &:focus-visible {
      outline: 3px solid ${REGISTRATION_FOCUS_RING};
      outline-offset: 2px;
    }

    &:disabled {
      opacity: 0.45;
      cursor: not-allowed;
    }
  }

  .btn-ghost,
  .btn-link-inline {
    ${registrationButtonBase}
    border: 1.5px solid rgba(30, 42, 53, 0.2);
    background: #ffffff;
    color: #5a6b80;
    margin-top: 10px;

    &:hover:not(:disabled) {
      background: ${REGISTRATION_HOVER_FILL};
      border-color: ${REGISTRATION_FOCUS_RING};
    }

    &:focus-visible {
      outline: 3px solid ${REGISTRATION_FOCUS_RING};
      outline-offset: 2px;
    }

    &:disabled {
      opacity: 0.45;
      cursor: not-allowed;
    }
  }

  .payment-method-review {
    border: 1.5px solid rgba(30, 42, 53, 0.12);
    border-radius: 12px;
    background: #f8faf6;
    padding: 18px 16px;
    margin-bottom: 20px;
  }

  .payment-method-review-title {
    margin: 0 0 10px;
    font-size: 15px;
    font-weight: 700;
    color: #2d3f52;
    font-family: ${REGISTRATION_FONT_BODY};
  }

  .payment-method-review-line {
    margin: 0 0 6px;
    font-size: 14px;
    line-height: 1.4;
    color: #2a2a2a;
    font-family: ${REGISTRATION_FONT_BODY};
  }

  .payment-method-review-card {
    font-weight: 600;
    font-size: 15px;
  }

  .payment-method-review-status {
    margin: 10px 0 0;
    font-size: 13px;
    color: #5a6b80;
    font-family: ${REGISTRATION_FONT_BODY};
  }

  .card-on-file-header-row {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 0;
  }

  .card-on-file-header-row .section-title {
    margin-bottom: 0;
    flex: 1;
  }

  .btn-card-edit {
    flex-shrink: 0;
    margin-top: 2px;
    padding: 8px 14px;
    border-radius: 999px;
    border: 1.5px solid rgba(30, 42, 53, 0.2);
    background: #ffffff;
    color: #2d3f52;
    font-family: ${REGISTRATION_FONT_BODY};
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;

    &:hover:not(:disabled) {
      background: ${REGISTRATION_HOVER_FILL};
      border-color: ${REGISTRATION_FOCUS_RING};
    }

    &:focus-visible {
      outline: 3px solid ${REGISTRATION_FOCUS_RING};
      outline-offset: 2px;
    }

    &:disabled {
      opacity: 0.45;
      cursor: not-allowed;
    }
  }

  .insurance-hero {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 20px;
  }

  .insurance-hero-icon {
    width: 44px;
    height: 44px;
    border-radius: 12px;
    background: rgba(174, 206, 56, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    color: ${REGISTRATION_LINK};
  }

  .insurance-hero-title {
    font-family: ${REGISTRATION_FONT_DISPLAY};
    font-size: 20px;
    font-weight: 500;
    color: ${REGISTRATION_FOREST};
    line-height: 1.2;
    margin: 0;
  }

  .insurance-hero-eyebrow {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 1.2px;
    text-transform: uppercase;
    color: ${REGISTRATION_LINK};
    margin-bottom: 2px;
    font-family: ${REGISTRATION_FONT_BODY};
  }

  .insurance-card-upload {
    margin-top: 4px;
    border: 0;
    padding: 0;
    min-width: 0;
  }

  .insurance-card-upload-title {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.8px;
    color: ${REGISTRATION_FOREST};
    margin-bottom: 8px;
    padding: 0;
    font-family: ${REGISTRATION_FONT_BODY};
  }

  .insurance-card-upload-desc {
    font-size: 14px;
    color: #5a6b80;
    line-height: 1.45;
    margin: 0 0 14px;
    font-family: ${REGISTRATION_FONT_BODY};
  }

  .insurance-card-upload-grid {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    gap: 16px;
    padding: 4px;

    @media (max-width: 640px) {
      grid-template-columns: minmax(0, 1fr);
    }
  }

  .insurance-card-upload-slot {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 0;
  }

  .insurance-card-upload-box {
    position: relative;
    width: 100%;
    aspect-ratio: 1.4 / 1;
    min-height: 120px;
    border-radius: 12px;
    background: #f5f5f5;
    overflow: visible;
    cursor: pointer;
  }

  .insurance-card-upload-replace,
  .insurance-card-upload-empty {
    display: block;
    position: relative;
    width: 100%;
    height: 100%;
    border: none;
    padding: 0;
    margin: 0;
    background: transparent;
    cursor: pointer;
    font: inherit;
    color: inherit;
    border-radius: 12px;

    &:focus-visible {
      outline: 3px solid ${REGISTRATION_FOCUS_RING};
      outline-offset: 2px;
      box-shadow: 0 0 0 3px ${REGISTRATION_FOCUS_GLOW};
      z-index: 1;
    }
  }

  .insurance-card-upload-preview {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    border-radius: 12px;
  }

  .insurance-card-upload-placeholder {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${REGISTRATION_PLACEHOLDER};

    svg {
      width: 40px;
      height: 40px;
    }
  }

  .insurance-card-upload-delete {
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 2;
    width: 28px;
    height: 28px;
    border: none;
    border-radius: 50%;
    background: ${REGISTRATION_PRIMARY};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 0;
    box-shadow: 0 1px 4px rgba(30, 42, 53, 0.18);

    svg {
      width: 14px;
      height: 14px;
      fill: ${REGISTRATION_ON_PRIMARY};
    }

    &:focus-visible {
      outline: 3px solid ${REGISTRATION_FOCUS_RING};
      outline-offset: 2px;
    }
  }

  .insurance-card-upload-label {
    margin-top: 10px;
    font-size: 14px;
    color: #5a6b80;
    font-family: ${REGISTRATION_FONT_BODY};
    text-align: center;
  }

  .insurance-upload-source-overlay {
    position: fixed;
    inset: 0;
    z-index: 1200;
    background: rgba(30, 42, 53, 0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
  }

  .insurance-upload-source-sheet {
    width: 100%;
    max-width: 420px;
    background: #fff;
    border-radius: 16px;
    padding: 16px;
    box-shadow: 0 12px 32px rgba(30, 42, 53, 0.18);
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .insurance-upload-source-title {
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.6px;
    text-transform: uppercase;
    color: ${REGISTRATION_FOREST};
    text-align: center;
    margin-bottom: 4px;
    font-family: ${REGISTRATION_FONT_BODY};
  }

  .insurance-upload-source-option,
  .insurance-upload-source-cancel {
    width: 100%;
    border: 1px solid rgba(90, 107, 128, 0.18);
    border-radius: 10px;
    background: #f7f8f6;
    color: #2d3f52;
    font-size: 15px;
    font-weight: 600;
    font-family: ${REGISTRATION_FONT_BODY};
    padding: 14px 16px;
    cursor: pointer;
    text-align: center;
  }

  .insurance-upload-source-option:hover,
  .insurance-upload-source-cancel:hover {
    background: ${REGISTRATION_HOVER_FILL};
    border-color: ${REGISTRATION_FOCUS_RING};
  }

  .insurance-upload-source-cancel {
    margin-top: 4px;
    background: #fff;
    color: ${REGISTRATION_FOREST};
    font-weight: 500;
  }

  .insurance-camera-overlay {
    position: fixed;
    inset: 0;
    z-index: 1300;
    background: rgba(30, 42, 53, 0.72);
    display: flex;
    align-items: flex-start;
    justify-content: center;
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    padding: max(16px, env(safe-area-inset-top, 0px)) 16px
      max(16px, env(safe-area-inset-bottom, 0px));
    box-sizing: border-box;
  }

  .insurance-camera-panel {
    width: 100%;
    max-width: 520px;
    margin: auto;
    background: #fff;
    border-radius: 16px;
    padding: 16px;
    box-shadow: 0 12px 32px rgba(30, 42, 53, 0.22);
    box-sizing: border-box;
  }

  .insurance-camera-preview-wrap {
    position: relative;
    width: 100%;
    aspect-ratio: 4 / 3;
    max-height: min(42dvh, 320px);
    border-radius: 12px;
    overflow: hidden;
    background: #1e2a35;
  }

  .insurance-camera-video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .insurance-camera-loading {
    position: absolute;
    inset: 0;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 14px;
    font-family: ${REGISTRATION_FONT_BODY};
    background: rgba(30, 42, 53, 0.45);
  }

  .insurance-camera-actions {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    margin-top: 14px;

    @media (max-width: 640px) {
      grid-template-columns: 1fr;
    }

    .insurance-upload-source-cancel {
      margin-top: 0;
    }
  }

  .insurance-camera-capture-btn {
    margin: 0;
  }
`;
